// extracted by mini-css-extract-plugin
export var blue = "_3j-f";
export var brand = "_3j-b";
export var darkGrey = "_3j-e";
export var disabled = "_3j-4";
export var disabledSubtle = "_3j-5";
export var error = "_3j-6";
export var green = "_3j-g";
export var grey = "_3j-d";
export var icon = "_3j-0";
export var inherit = "_3j-a";
export var lightGrey = "_3j-c";
export var orange = "_3j-i";
export var pink = "_3j-k";
export var primary = "_3j-1";
export var purple = "_3j-l";
export var red = "_3j-j";
export var secondary = "_3j-2";
export var success = "_3j-9";
export var tertiary = "_3j-3";
export var warning = "_3j-7";
export var warningSecondary = "_3j-8";
export var white = "_3j-m";
export var yellow = "_3j-h";